var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNexusUiSigil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Nexus arena arcane UI sigil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "blueGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(450 450) rotate(90) scale(410)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38bdf8",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2563eb",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7c3aed",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020617",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldLine",
    x1: 118,
    y1: 136,
    x2: 782,
    y2: 764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8d477",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8d477",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8d477",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: 0,
    y: 0,
    width: 900,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blur",
    type: "matrix",
    values: "0 0 0 0 0.19 0 0 0 0 0.57 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    mode: "screen"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 410,
    fill: "url(#blueGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 274,
    stroke: "#38bdf8",
    strokeOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 210,
    stroke: "url(#goldLine)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 142,
    stroke: "#7c3aed",
    strokeOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 146L532 368L754 450L532 532L450 754L368 532L146 450L368 368L450 146Z",
    stroke: "url(#goldLine)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 218L514 386L682 450L514 514L450 682L386 514L218 450L386 386L450 218Z",
    stroke: "#38bdf8",
    strokeOpacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 270H630V630H270V270Z",
    stroke: "#f8d477",
    strokeOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 210H582M318 690H582M210 318V582M690 318V582",
    stroke: "#38bdf8",
    strokeOpacity: 0.22,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexusUiSigil);
export default __webpack_public_path__ + "static/media/nexus-ui-sigil.ee2d2d79e710a17fbcd56017bbbbdd72.svg";
export { ForwardRef as ReactComponent };